"use client";

import { SocialScreen } from "@/features/social/SocialScreen";

export default function SocialPage() {
  return <SocialScreen />;
}
